import React, { createContext, useState, useEffect } from "react";
import axiosInstance from "../../shared/api/axios";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState("");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = urlParams.get("token");

    if (tokenFromUrl) {
      setToken(tokenFromUrl);
    }
  }, []);

  if (!token) {
    return <div>Unauthorized. Please log in to access this page.</div>;
  }

  axiosInstance.defaults.headers.common["Authorization"] = `Token ${token}`;

  return (
    <AuthContext.Provider value={{ token }}>{children}</AuthContext.Provider>
  );
};
